import { JSX, ReactNode, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import * as constent from "util/constent";
import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import "../modal.scss";

type IProps = {};

export default function Modal({}: IProps) {
  const { t } = useTranslation();
  const btnRef = useRef<HTMLButtonElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);
  const modalLayoutRef = useRef<HTMLElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [ttl, setTtl] = useState("");
  const [chckBtn, setOkBtton] = useState(true);
  const [btnTxt, setBtnTxt] = useState(t("btn_hm_cnf"));
  const [inner, setInner] = useState<JSX.Element | ReactNode>();
  const [disabled, setDisabled] = useState(false);
  const [styles, setStyles] = useState("");

  const getModalInf = (e: any) => {
    const {
      isOpen,
      ttl,
      chckBtn,
      btnTxt,
      disabled,
      inner,
      keep,
      styles,
      click,
    } = e.detail;

    if (!keep) {
      setIsOpen(isOpen);
    }
    setTtl(ttl);
    setOkBtton(chckBtn);
    btnTxt && setBtnTxt(btnTxt);
    setStyles(styles);
    setDisabled(disabled);
    setInner(inner);

    if (click) {
      setTimeout(() => {
        btnRef.current?.addEventListener("click", click);
      }, 100);
    }
  };

  useEffect(() => {
    window.addEventListener(constent.CONST_COMM_MODAL_CONTROL, getModalInf);
    return () => {
      window.removeEventListener(
        constent.CONST_COMM_MODAL_CONTROL,
        getModalInf
      );
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflow = "hidden";
      if (modalRef.current && modalLayoutRef.current) {
        const clssNm = modalRef.current.className;
        clssNm.includes("modal-full")
          ? (modalLayoutRef.current.className = "modal-layout modal-full")
          : (modalLayoutRef.current.className = "modal-layout");
      }
    }
    return () => {
      window.document.body.style.overflow = "auto";
      if (modalLayoutRef.current) {
        modalLayoutRef.current.className = "modal-layout";
      }
    };
  }, [isOpen]);

  return (
    isOpen && (
      <section>
        {createPortal(
          <section className={"modal-layout"} ref={modalLayoutRef}>
            <div ref={modalRef} className={"modal" + " " + styles}>
              <div className="between-center w-full ">
                <button
                  className="btn-close"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                />
              </div>
              {inner}
              {chckBtn && (
                <div className="flex justify-center">
                  <Button
                    text={btnTxt}
                    ref={btnRef}
                    styels="w-[116px] font-14"
                    disabled={disabled}
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  />
                </div>
              )}
            </div>
          </section>,
          document.body
        )}
      </section>
    )
  );
}
